// src/Components/Orders Main/ui/StatusBadge.jsx
import React from "react";

const StatusBadge = ({ color, Icon, label }) => {
  return (
    <span
      className="inline-flex items-center justify-center gap-1 px-3 py-1 rounded-full text-[12px] font-medium"
      style={{ background: `${color}1A`, color }}
      title={label}
    >
      {Icon ? <Icon size={14} /> : null}
      <span className="min-w-[96px] text-center">{label}</span>
    </span>
  );
};

export default StatusBadge;
